import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { toInterfaceHour } from 'utils/date';

import OrderHelp from 'components/OrderHelp';
import {
  Container,
  Tabs,
  Tab,
  Card,
  WarnCard,
  WarnText,
  Row,
  Avatar,
  Text,
  LocationText,
  TextGrey,
  OrderIcon,
  HashIcon,
  ClockIcon,
  PhoneIcon,
  LocationIcon,
  IconUser,
  WrapperIcon,
} from './styles';
import { Props, AddressProps } from './types';

const Adress: FC<AddressProps> = ({ address }) => {
  if (
    !(
      address.addressLine1.trim() ||
      address.addressLine2.trim() ||
      address.city.trim() ||
      address.state.trim() ||
      address.zipCode.trim()
    )
  ) {
    return <>No Address Provided</>;
  }

  return (
    <>
      {address.addressLine1} <br />
      {address.addressLine2} <br />
      {address.city}, {address.state} {address.zipCode}
    </>
  );
};

const ExtraInfo: FC<Props> = ({ order }) => {
  return (
    <Container>
      <Tabs>
        <Tab label="Order" exact to={`/orders/${order.id}`} />
        <Tab label="Customer" to={`/orders/${order.id}/customer`} />
        {/* <Tab label="Courier" to={`/orders/${order.id}/courier`} /> */}
      </Tabs>
      <Switch>
        <Route path={`/orders/${order.id}/customer`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>

              <Text>{order.customer.name.displayName}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <PhoneIcon />
              </WrapperIcon>

              <Text>{order.customer.phone || 'No phone provided'}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <LocationIcon />
              </WrapperIcon>

              <LocationText>
                <Adress address={order.customer.address} />
              </LocationText>
            </Row>
          </Card>
        </Route>
        {/* <Route path={`/orders/${order.id}/courier`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>
              <Text>{order.courier.name.displayName}</Text>
            </Row>
            {order.courier.phone && (
              <Row>
                <WrapperIcon>
                  <PhoneIcon />
                </WrapperIcon>

                <Text>{order.courier.phone}</Text>
              </Row>
            )}
          </Card>
        </Route> */}
        <Route path={`/orders/${order.id}`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>
              <Text>{order.customer.name.displayName}</Text>
            </Row>
            <Row>
              <Avatar
                src={order.integration.logo}
                alt={order.integration.name}
              />
              <Text>{order.integration.name}</Text>
              {/* <TextGrey>· {order.integration.orderId}</TextGrey> */}
            </Row>
            <Row>
              <WrapperIcon>
                <HashIcon />
              </WrapperIcon>
              <Text>{order.integrationOrderId}</Text>
            </Row>
            <Row>
              <Avatar src={order.brand.logo} alt={order.brand.name} />
              <Text>{order.brand.name}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <OrderIcon />
              </WrapperIcon>

              <Text>{order.itemCount} items</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <ClockIcon />
              </WrapperIcon>
              <Text>{toInterfaceHour(order.createdAt)}</Text>
              <TextGrey>· {order.type.caption}</TextGrey>
            </Row>
          </Card>
        </Route>
      </Switch>
      <WarnCard>
        <WarnText>
          <OrderHelp integrationName={order.integration.name} />
        </WarnText>
      </WarnCard>
    </Container>
  );
};

export default ExtraInfo;
